import {normalize, schema, denormalize} from 'normalizr';

const attributeLanguage = new schema.Entity('attributesLanguages', {}, {idAttribute: "id"});

export function normalizeDatos(myData) {

    const mySchema = {attributesLanguages: [attributeLanguage]};
    const normalizedData = normalize(myData, mySchema);
    return normalizedData;
}


export function normalizeDato(myData) {

    const mySchema = attributeLanguage;
    const normalizedData = normalize(myData, mySchema);

    return normalizedData;
}

export function denormalizeDato(myData, store) {

    const mySchema = attributeLanguage;

    const normalizedData = denormalize(myData, mySchema, store);

    return normalizedData;
}

export default attributeLanguage;
